import React, { createContext, useContext } from "react";

/**
 * Priority 3: Query Orchestration Provider
 * 
 * This is a lightweight provider that sets up the context for query orchestration.
 * The actual orchestrated queries are available through dedicated hooks and utilities:
 * 
 * - useOrchestrationBatchedUserData() - Batch user + settings queries
 * - useOrchestrationMeetingQueries() - Batch notifications + action items
 * - useRequestCoalescing() - Deduplicate identical requests
 * - requestCoalescer - Global request deduplication utility
 * 
 * Components can opt-in to using these orchestrated queries instead of making
 * individual hook calls, which reduces API call count and improves performance.
 * 
 * See: src/hooks/use-query-orchestration.ts
 * See: src/utils/request-coalescer.ts
 */
// eslint-disable-next-line react-refresh/only-export-components
export const OrchestrationContext = createContext<{ enabled: boolean } | undefined>(undefined);

export const OrchestrationProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <OrchestrationContext.Provider value={{ enabled: true }}>
      {children}
    </OrchestrationContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export { useOrchestration } from './use-orchestration';
